import { Skeleton } from '@mantine/core';
import classes from './PageSkeleton.module.css';

/** Page-shaped loading state (eyebrow, heading, three tiles, one panel). Never a spinner. */
export function PageSkeleton() {
  return (
    <div className={classes.root} aria-busy="true" aria-label="Loading">
      <Skeleton height={14} width="30%" radius="sm" />
      <Skeleton height={40} width="55%" radius="sm" />
      <div className={classes.tiles}>
        <div className={classes.card} style={{ height: 180 }} />
        <div className={classes.card} style={{ height: 180 }} />
        <div className={classes.card} style={{ height: 180 }} />
      </div>
      <div className={classes.card} style={{ height: 260 }} />
    </div>
  );
}

/** Smaller skeleton for a single panel's body (lists, detail panes). */
export function PanelSkeleton({ rows = 3 }: { rows?: number }) {
  return (
    <div className={classes.panelRows} aria-busy="true" aria-label="Loading">
      {Array.from({ length: rows }, (_, i) => (
        <div key={i} className={classes.row}>
          <Skeleton circle height={36} width={36} />
          <div className={classes.rowText}>
            <Skeleton height={12} width="60%" radius="sm" />
            <Skeleton height={12} width="40%" radius="sm" />
          </div>
        </div>
      ))}
    </div>
  );
}
